import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThemeModule } from '@sentry/theme';

@NgModule({
  imports: [CommonModule, ThemeModule],
  exports: [],
})
export class MediaModule {}
